// Quotes waiting for the customer: pending quotes on requests that are still open.
// Nothing tells the customer a quote arrived (UX audit 26/10, 8.א), so the site shows
// this count on the request card and as a badge on the way to the personal area.

export type RequestRow = { id: string; status: string };
export type QuoteRow = { request_id: string; status: string };

export const waitingQuotesByRequest = (requests: RequestRow[], quotes: QuoteRow[]): Record<string, number> => {
  const open = new Set(requests.filter(r => r.status === 'active').map(r => r.id));
  const counts: Record<string, number> = {};
  for (const q of quotes) {
    if (q.status === 'pending' && open.has(q.request_id)) counts[q.request_id] = (counts[q.request_id] ?? 0) + 1;
  }
  return counts;
};

export const totalWaiting = (byRequest: Record<string, number>): number =>
  Object.values(byRequest).reduce((sum, n) => sum + n, 0);
